import React, { Component } from "react";
import axios from "axios";
import dayjs from "dayjs";

import TablePagination from "@mui/material/TablePagination";

import {
  Container,
  Paper,
  Grid,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import API_URL from "./Apiurl";

import SearchIcon from '@mui/icons-material/Search';
import TableSortLabel from "@mui/material/TableSortLabel";



const headCells = [
  { id: "projectname", label: "Project" },
  { id: "vendorname", label: "Vendor" },
  { id: "purchasedate", label: "Purchase Date" },
  { id: "amount", label: "Amount" },
  { id: "bill", label: "Bill" },
];
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

function stableSort(array, cmp) {
  const stabilized = array.map((el, index) => [el, index]);

  stabilized.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  return stabilized.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;

  const createSortHandler = (property) => () => {
    onRequestSort(property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
            onClick={createSortHandler(headCell.id)}
            style={{ fontWeight: "normal", cursor: "pointer" }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}


class VendorPaymentsReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromDate: dayjs().startOf("month"),
      toDate: dayjs(),
      projectId: "",
      vendorId: "",
      projects: [],
      vendors: [],
	  
	    projectarray: [],
  projectarrauto: [],
  selectedProject: null,

  vendorarray: [],
  vendorarrauto: [],
  selectedVendor: null,
  order: "asc",
orderBy: "",
	  
	  
      reportData: [],
	  loading: false,
      error: "",
      page: 0,
      rowsPerPage: 10,
	  totalRecords: 0,
	 
    };
  }

  componentDidMount() {
    this.fetchProjects();
    this.fetchVendors();
    this.fetchReport();
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  fetchProjects = () => {
  axios
    .get(API_URL + "ajaxprojects.php", {
      params: { action: "getallprojectautoextender" },
    })
    .then((res) => {
      const list = (res.data || []).map((x) => ({
        title: x.pj_projectname,
        pj_id: x.pj_id,
      }));

      this.setState({ projectarrauto: list });
    });
};

fetchVendors = () => {
  axios
    .get(API_URL + "ajaxvendor.php", {
      params: { action: "getallautoextender" },
    })
    .then((res) => {
      const list = (res.data || []).map((x) => ({
        title: x.vm_vendorname,
        vm_id: x.vm_id,
      }));

      this.setState({ vendorarrauto: list });
    });
};
  
  
  //report
   fetchReport = (e) => {
    if (e) e.preventDefault();

    this.setState({ loading: true });

    axios
      .get(API_URL + "ajaxvendorpaymentsreport.php", {
        params: {
          action: "getvendorpaymentsreport",
          from_date: this.state.fromDate
            ? this.state.fromDate.format("YYYY-MM-DD")
            : "",
          to_date: this.state.toDate
            ? this.state.toDate.format("YYYY-MM-DD")
            : "",
          project_id: this.state.projectId,
          vendor_id: this.state.vendorId,
          index: this.state.page,
          maxrecord: this.state.rowsPerPage,
          orderby: "mp.mp_date DESC",
        },
      })
      .then((res) => {
        this.setState({
          reportData: res.data || [],
          totalRecords: res.data?.[0]?.count || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
          error: "Error loading report",
        });
      });
  };


 downloadBill = (file) => {
    if (file) {
      window.open(API_URL + "uploads/" + file, "_blank");
    }
  };

  
  
  handlePageChange = (event, newPage) => {
  this.setState({ page: newPage }, () => {
    this.fetchReport();
  });
};

handleRowsChange = (event) => {
  this.setState(
    {
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0
    },
    () => this.fetchReport()
  );
};
  
  /*PROJECT AUTOEXTENDER*/
  onloadProjectBind = (event) => {
   axios.get(API_URL + "ajaxprojects.php", {
      params: {
        action: "getallautoextender",
        projectname: event.target.value
      }
    })
    .then((resp) => {
      let strCust = [];

      (resp.data || []).forEach((row) => {
        const item = {
          title: row.pj_projectname,
          pj_id: row.pj_id,
          rowindex: row.rowindex
        };

        const found = strCust.some(
          (el) => el.pj_id === row.pj_id
        );

        if (!found) {
          strCust.push(item);
        }
      });

      this.setState({
        projectarray: resp.data || [],
        projectarrauto: strCust
      });
    });
};

onProjectChange = (event, value) => {
  this.setState({
    selectedProject: value,
    projectId: value ? value.pj_id : ""
  });
};

/*VENDOR AUTOEXTENDER*/

onloadVendorBind = (event) => {
  axios
    .get(API_URL + "ajaxvendor.php", {
      params: {
        action: "getallautoextender",
        vendorname: event.target.value
      }
    })
    .then((resp) => {
      let strCust = [];

      (resp.data || []).forEach((row) => {
        const item = {
          title: row.vm_vendorname,
          vm_id: row.vm_id,
          rowindex: row.rowindex
        };

        const found = strCust.some(
          (el) => el.vm_id === row.vm_id
        );

        if (!found) {
          strCust.push(item);
        }
      });

      this.setState({
        vendorarray: resp.data || [],
        vendorarrauto: strCust
      });
    });
};

onVendorChange = (event, value) => {
  this.setState({
    selectedVendor: value,
    vendorId: value ? value.vm_id : ""
  });
};

handleRequestSort = (property) => {
  const isAsc =
    this.state.orderBy === property && this.state.order === "asc";

  this.setState({
    order: isAsc ? "desc" : "asc",
    orderBy: property,
  });
};
 

  render() {
    const { reportData } = this.state;

    const totalAmount = reportData.reduce(
      (sum, row) => sum + (parseFloat(row.amount) || 0),
      0
    );

    return (
      <div className="containermain">
  <Paper className="container">
          <div className="boxheading">
  <div className="contntpad">
    <h2>Vendor Payments Report</h2>
  </div>
</div>

          
   <div className="searchmaster">
  <ul>

    <li>
           <p>From Date</p>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={this.state.fromDate}
          onChange={(newValue) => this.setState({ fromDate: newValue })}
          format="MM/DD/YYYY"
          slotProps={{ textField: { fullWidth: true, size: "small" } }}
        />
		</LocalizationProvider>
     </li>

      <li>
      <p>To Date</p>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          value={this.state.toDate}
          onChange={(newValue) => this.setState({ toDate: newValue })}
          format="MM/DD/YYYY"
          slotProps={{ textField: { fullWidth: true, size: "small" } }}
        />
		</LocalizationProvider>
      </li>

     <li>
      <p>Project</p>

 <Autocomplete
        options={this.state.projectarrauto}
        value={this.state.selectedProject}
        onChange={this.onProjectChange}
        getOptionLabel={(o) => o.title || ""}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Search Project"
            onChange={this.onloadProjectBind}
          />
        )}
      />
</li>

     <li>
      <p>Vendor</p>

  <Autocomplete
  options={this.state.vendorarrauto}
  value={this.state.selectedVendor}
  onChange={this.onVendorChange}
  getOptionLabel={(option) => option.title || ""}
  renderInput={(params) => (
    <TextField
      {...params}
      size="small"
      placeholder="Search Vendor"
      onChange={this.onloadVendorBind}
    />
  )}
  renderOption={(props, option) => (
    <li {...props}>
      {option.title}
    </li>
  )}
  fullWidth
/>
</li>

       <li>
      <p className="searchbutton">
         <Button
          variant="contained"
          onClick={this.fetchReport}
          endIcon={<SearchIcon />}
        >
          Search
        </Button></p>
      </li>
    </ul>
  </div>



          <TableContainer>
            <Table>
           <EnhancedTableHead
  order={this.state.order}
  orderBy={this.state.orderBy}
  onRequestSort={this.handleRequestSort}
/>

              <TableBody>
                {stableSort(
  reportData,
  getSorting(this.state.order, this.state.orderBy)
).map((r, i) => (
                  <TableRow key={i} hover>
                    <TableCell>{r.projectname}</TableCell>
                    <TableCell>{r.vendorname}</TableCell>
                    <TableCell>
                      {r.purchasedate ? dayjs(r.purchasedate).format("DD/MM/YYYY") : ""}
                    </TableCell>
                    <TableCell>₹ {parseFloat(r.amount || 0).toFixed(2)}</TableCell>
                    <TableCell>
                      <Button size="small" onClick={() => this.downloadBill(r.bill)}>
                        Download
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}

                {/* Total row */}
                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                  <TableCell colSpan={3} align="right">
                    <strong>Total</strong>
                  </TableCell>
                  <TableCell>
                    <strong>₹ {totalAmount.toFixed(2)}</strong>
                  </TableCell>
                  <TableCell />
                </TableRow>
              </TableBody>
            </Table>
			
			<TablePagination
  component="div"
  count={this.state.totalRecords}
  page={this.state.page}
  onPageChange={this.handlePageChange}
  rowsPerPage={this.state.rowsPerPage}
  onRowsPerPageChange={this.handleRowsChange}
/>
			
			
          </TableContainer>
        </Paper>
      </div>
    );
  }
}

export default VendorPaymentsReport;